"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineReadingHelperForWordsInTexts = exports.displayUnitHelper = void 0;
var tabletUtils_1 = require("./tabletUtils");
var DiscourseRenderer = (function () {
    function DiscourseRenderer(discourseUnits, locale) {
        this.discourseUnits = discourseUnits;
        this.discourseUnits.sort(function (a, b) { return a.objInText - b.objInText; });
        this.locale = locale;
        this.renderClass = DiscourseRenderer;
    }
    Object.defineProperty(DiscourseRenderer.prototype, "sides", {
        get: function () {
            return getSides(this.discourseUnits);
        },
        enumerable: false,
        configurable: true
    });
    DiscourseRenderer.prototype.linesOnSide = function (side) {
        return getSideLines(side, this.discourseUnits);
    };
    DiscourseRenderer.prototype.wordsOnLine = function (line) {
        var _this = this;
        var words = [];
        displayUnitHelper(this.discourseUnits, line, words);
        return words.map(function (word) { return (__assign(__assign({}, word), { display: (0, tabletUtils_1.localizeString)(word.display, _this.locale) })); });
    };
    DiscourseRenderer.prototype.lineReading = function (line) {
        var _this = this;
        var words = [];
        displayUnitHelper(this.discourseUnits, line, words);
        return words
            .map(function (word) { return (0, tabletUtils_1.localizeString)(word.display, _this.locale); })
            .join(' ');
    };
    DiscourseRenderer.prototype.isRegion = function (lineNum) {
        var types = getLineTypes(lineNum, this.discourseUnits);
        return types.includes('region');
    };
    return DiscourseRenderer;
}());
exports.default = DiscourseRenderer;
function getSides(units) {
    var sides = new Set();
    units.forEach(function (unit) {
        if (unit.side) {
            sides.add(unit.side);
        }
        var childrenSides = getSides(unit.units);
        childrenSides.forEach(function (side) { return sides.add(side); });
    });
    return Array.from(sides);
}
function getSideLines(side, units) {
    var lines = new Set();
    units.forEach(function (unit) {
        if (unit.line && unit.side === side) {
            lines.add(unit.line);
        }
        var childrenLines = getSideLines(side, unit.units);
        childrenLines.forEach(function (line) { return lines.add(line); });
    });
    return Array.from(lines);
}
function getLineTypes(line, units) {
    var types = new Set();
    units.forEach(function (unit) {
        if (unit.line === line) {
            types.add(unit.type);
        }
        var childrenTypes = getLineTypes(line, unit.units);
        childrenTypes.forEach(function (type) { return types.add(type); });
    });
    return Array.from(types);
}
function displayUnitHelper(units, line, words, renderFormatter) {
    if (renderFormatter === void 0) { renderFormatter = {
        transliteration: function (word) { return word; },
        spelling: function (word) { return word; },
    }; }
    units.forEach(function (unit) {
        if (unit.line === line) {
            if (unit.transcription) {
                words.push({
                    uuid: unit.uuid,
                    type: unit.type,
                    display: renderFormatter.transliteration(unit.transcription),
                });
            }
            else if (unit.explicitSpelling) {
                words.push({
                    uuid: unit.uuid,
                    type: unit.type,
                    display: renderFormatter.spelling(unit.explicitSpelling),
                });
            }
        }
        displayUnitHelper(unit.units, line, words, renderFormatter);
    });
}
exports.displayUnitHelper = displayUnitHelper;
function lineReadingHelperForWordsInTexts(units, discourseUuids, line, words, renderFormatter) {
    if (renderFormatter === void 0) { renderFormatter = {
        transliteration: function (word) { return word; },
        spelling: function (word) { return word; },
    }; }
    units.forEach(function (unit) {
        if (unit.line === line) {
            if (unit.transcription) {
                words.push(renderFormatter.transliteration(discourseUuids.includes(unit.uuid)
                    ? "<mark>".concat(unit.transcription, "</mark>")
                    : unit.transcription));
            }
            else if (unit.explicitSpelling) {
                words.push(renderFormatter.spelling(discourseUuids.includes(unit.uuid)
                    ? "<mark>".concat(unit.explicitSpelling, "</mark>")
                    : unit.explicitSpelling));
            }
        }
        lineReadingHelperForWordsInTexts(unit.units, discourseUuids, line, words, renderFormatter);
    });
}
exports.lineReadingHelperForWordsInTexts = lineReadingHelperForWordsInTexts;
//# sourceMappingURL=DiscourseRenderer.js.map